
import { takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
//shared libs
import { SelectizeComponent, ToastService } from '../../blocks';
import { AppCodeGroup, ControlsParams, UserSessionService } from '../../shared';
//ResourceType
import { Place, PlaceService } from './place.service';
import { TranslateService } from '@ngx-translate/core';
import { StepperComponent } from '../../blocks';
import { User } from '../userData/user.service';
import { Subject } from 'rxjs';
import { SecLoginsService, SecLogins } from '../secLogins/sec-logins.service';
@Component({
    selector: 'sanabel-place',
    styleUrls: ['./place.component.css'],
    templateUrl: './place.component.html'
})
export class PlaceComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    @Input() userCode: number;
    editUser: User = <User>{};
    SecLoginsID: number;
    activeTabSerial: number = 6935;
    defaultTab: number = 6934;
    controlsParams: ControlsParams;
    placePrivilegeObj: Place[] = [];
    @Input() myStepNumber: number;
    @Input() stepperComponent: StepperComponent;
    @ViewChild('seclOginSeclectize') seclOginSeclectize: SelectizeComponent;
    @ViewChild('resourceType') resourceTypeSeclectize: SelectizeComponent;

    /////////////////
    ResourceTypeArray: any[] = [];
    allChecked: boolean = false;
    allVplacesData: Place[] = [];
    allDataByLevel: any[] = [];
    resourceType: number;
    resourceCode: number;
    userID: number;
    roomsArray: any;
    SecLogins: SecLogins[];
    constructor(
        private _SecLoginsService: SecLoginsService,
        public translate: TranslateService,
        private _toastService: ToastService,
        private _userSessionService: UserSessionService,
        private _placeService: PlaceService) {
        this.controlsParams = new ControlsParams(555, AppCodeGroup.Buttons, true);

    }

    ngOnInit() {
        this._userSessionService.subscribeToKey$('userParms').pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.value) {
                    this.userID = keys.value['userID'];
                    this.getSecLogins();
                    // if (this.seclOginSeclectize) {
                    //     this.seclOginSeclectize.clear();
                    //     this.seclOginSeclectize.clearItems();
                    //     this.seclOginSeclectize.setFastSearchKey('SecUserId', keys.value['userID']);
                    // }
                }
            });
        this.getDataLevel(2);

    }

    onClicked(e: number): void {
        switch (e) {
            case 1: //save code
                this.save();
                break;
        }
    }

    ////////////////////////////////////////////////////////#Gouhar///////////////////////////////////////////
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.resetForm();
    }

    resetForm() {
        //this.seclOginSeclectize.clear();
        //this.seclOginSeclectize.clearItems();
        this.allVplacesData = [];
        this.ResourceTypeArray = [];

    }

    // SecLoginsClicked(item: any) {
    //     // if (item && item.active == 0 && item.active != null) {
    //     //     this._toastService.activateMsg('UI48');
    //     //     this.resetForm();
    //     //     return false;
    //     // }

    //     // if (item) {
    //     //     this.SecLoginsID = item.id;
    //     // }
    // }
    // resourceTypeClicked(item: any) {
    //     // if (item && item.active == 0 && item.active != null) {
    //     //     this._toastService.activateMsg('UI48');
    //     //     this.resetForm();
    //     //     return false;
    //     // }
    //     // if (item) {
    //     //     this.resourceType = item.code;
    //     //     this.getsecloginVPlaces();
    //     // }
    // }
    showFilterTabs: boolean=false
    getsecloginVPlaces() {
        this.ResourceTypeArray = [];
        this.allDataByLevel = [];
        this.showFilterTabs = false
this._placeService.getPlaces(this.resourceType, this.SecLoginsID).pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe(c => {
                if(c &&c.data&&c.data.length>0){
                this.ResourceTypeArray = c.data;

                this.resourceCode = c.data[0].resourceCode;
                if (this.resourceCode) {
                    if ([11, 13, 14, 15].includes(this.resourceCode))
                        this.showFilterTabs = true
                    else
                        this.showFilterTabs = false
                }}
            });
    }
    // select a service
    selectedResourceTypes(service: any) {
        service.selected = !service.selected;
    }
    toggleAll() {
        this.allChecked = !this.allChecked;
        for (var i = 0; i < this.ResourceTypeArray.length; i++) {
            this.ResourceTypeArray[i].selected = this.allChecked;
        }
    }
    getlevelNumber(ev: any) {
        switch (ev.appCode) {
            case 6932: 
                this.getDataLevel(2);
                break;
            case 6934:
                this.getDataLevel(3);
                break;
            case 6935:
                this.getDataLevel(4);
                break;
        }
    }
    getDataLevel(levelNo: number) {

        this.allDataByLevel = this.ResourceTypeArray.filter(row => row.levelNo == levelNo);
    }



    ////////////////////////////////
    save() {
        this.allVplacesData = [];
        if (this.SecLoginsID) {
            for (var i = 0; i < this.ResourceTypeArray.length; i++) {
                if ((this.ResourceTypeArray[i].id > 0 && !this.ResourceTypeArray[i].selected) || (this.ResourceTypeArray[i].selected && this.ResourceTypeArray[i].id == null)) {
                    var prem: Place = {
                        id: (this.ResourceTypeArray[i].id ? this.ResourceTypeArray[i].id : (i + 1) * -1),
                        secLoginId: this.SecLoginsID,
                        vplacesId: this.ResourceTypeArray[i].resourceId,
                        selected: this.ResourceTypeArray[i].selected,
                        levelNo: 0,
                        ResourceCode: 0
                    }
                    this.allVplacesData.push(prem);
                }

            }
            this._placeService.addPlace(this.allVplacesData).pipe(
                takeUntil(this.ngUnsubscribe))
                .subscribe(c => {
                    if (c["returnFlag"]) {
                        this.getsecloginVPlaces();
                    }
                });
        } else {
            this._toastService.activateMsg('UI234');
            return false;
        }
    }

    ///////// new add on

    getSecLogins() {
        if (this.userID) {
            this._SecLoginsService.getSecLogins(this.userID).pipe(
                takeUntil(this.ngUnsubscribe))
                .subscribe(
                    SecLogins => {
                        this.SecLogins = [];
                        this.SecLogins = SecLogins.data;
                        this.SecLogins[0]['status'] = 1;
                        this.roomsArray = SecLogins.data1;
                    },
                    error => console.log(error),
                    () => {
                        this.SecLoginsID = this.SecLogins[0].id;
                    });
        }

    }

    SecLoginsClicked(_name: any) {
        this.SecLogins.forEach(element => {
            element['status'] = 0;
        });
        _name.status = !_name.status;
        this.SecLoginsID = _name.id;
    }

    resourceTypeClicked(_name: any) {
        this.roomsArray.forEach(element => {
            element['active'] = 0;
        });
        _name.active = !_name.active;
        this.resourceType = _name.code;
        this.getsecloginVPlaces();
    }

}
